export default {
  title: 'Наши сервисы',
  consulting: {
    title: 'Консалтинг',
    description: 'Профессиональная помощь в принятии решений на рынке недвижимости.',
    more: 'Подробнее',
  },
  ai_valuation: {
    title: 'Оценка с помощью ИИ',
    description: 'Мгновенная оценка стоимости недвижимости с использованием алгоритмов.',
    more: 'Узнать больше',
  },
  market_analytics: {
    title: 'Аналитика рынка',
    description: 'Регулярные отчеты о состоянии и трендах рынка недвижимости.',
    more: 'Читать',
  },
  data_security: {
    title: 'Защита данных',
    description: 'Современные методы хранения и обработки вашей информации.',
    more: 'Подробнее',
  },
  automation: {
    title: 'Автоматизация',
    description: 'Снижение ручной работы за счёт автоматизации процессов.',
    more: 'Показать',
  },
  internet_solutions: {
    title: 'Интернет-решения',
    description: 'Интеграция с цифровыми сервисами и IoT для умных домов.',
    more: 'Узнать',
  }
}
